const type = 'SET_LIMIT_PROPOSAL_NEXT_LIMIT';

const setLimitProposalNextLimit = (data = {}) => ({
  data,
  type,
});

export { type };
export default setLimitProposalNextLimit;
